<template>
  <div>
    <router-view />
  </div>
</template>


<style lang="sass">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC&display=swap')
html
  font-family: 'Noto Sans TC'

.font-light
  font-family: noto-sans-light

.font-regular
  font-family: noto-sans-regular

.font-medium
  font-family: noto-sans-medium

.text-right
  text-align: right

.text-left
  text-align: left

button.simple
  border: none
  cursor: pointer
  color: rgb(0, 19, 145)
  text-align: center
  background: transparent
  font-weight: 500

.text-s
  font-size: 12px

.text-m
  font-size: 14px
</style>